/*
  dtf-finance-terms.js
  ─────────────────────────────────────────────────────────────────────────────
  DTF Transfers PDP (templates product.by-size-bg-options and
  product.multiupload_vivid_v3 — the v3 layout reuses the same order column).

  After an upload, the post-upload column reads: PROCEED TO CHECKOUT → White Belt
  Cashback bar → "Complete your order with Blanks". This re-adds the "Finance with
  Buy Now Pay Later" row between the cashback bar and the Blanks upsell — matching
  uv-dtf-gang-sheet-builder, where the same block (snippet custom-payment-terms)
  is server-rendered in the sticky column.

  Why JS instead of editing the section: bySizeNew.liquid is ~433 KB, over
  Shopify's 256 KB per-file template limit, so it can't be pushed via CLI.
  theme.liquid loads this small asset globally; the script self-gates to the
  dtf-transfers + v3 templates and no-ops everywhere else.

  Placement: inserted as the previous sibling of the .grt-upsell ("Complete your
  order with Blanks") block inside .product-text.element--is-sticky, and only
  while that block is visible — the post-upload signal. Even 24px padding
  above/below; if the upload is cleared and the upsell hides, the row is removed.
*/
(function () {
  if (!document.body || !/(?:^|\s)template-product-(?:by-size-bg-options|multiupload_vivid_v3)(?:\s|$)/.test(document.body.className)) return;

  var FIN_CLASS = 'nt-injected-finance';
  var IMG = 'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/transfer-installments-121724.png?v=1734458882';

  function injectStyles() {
    if (document.getElementById('nt-finance-style')) return;
    var s = document.createElement('style');
    s.id = 'nt-finance-style';
    s.textContent =
      '.' + FIN_CLASS + '{margin:24px 0;}' +
      '.' + FIN_CLASS + ' .payment-terms-extra{text-align:center;font-size:13px;font-weight:500;margin:0 0 4px;color:#1F2937;}' +
      '.' + FIN_CLASS + ' .pay-icon-sets{display:flex;justify-content:center;align-items:center;}' +
      '.' + FIN_CLASS + ' .pay-icon-sets img{max-width:100%;height:auto;}' +
      '.' + FIN_CLASS + ' .payment-terms-disclaimer{text-align:center;font-size:8px;line-height:1.35;color:#8a8a8a;max-width:520px;margin:6px auto 0;padding:0 12px;}' +
      '@media(max-width:768px){.' + FIN_CLASS + ' .pay-icon-sets img{max-width:90%;}}';
    document.head.appendChild(s);
  }

  function buildFinance() {
    var w = document.createElement('div');
    w.className = 'grt-payment-terms-extra-block ' + FIN_CLASS;
    /* Disclaimer mirrors snippets/custom-payment-terms.liquid (same class +
       exact text) — keep the two copies in sync. */
    w.innerHTML =
      '<div class="payment-terms-extra">Finance with Buy Now Pay Later options</div>' +
      '<div class="d-flex align-items-center btngroup8 pay-icon-sets">' +
        '<img src="' + IMG + '" loading="lazy" alt="payment terms" width="400" height="26" />' +
      '</div>' +
      '<div class="payment-terms-disclaimer">Monthly financing through Klarna issued by WebBank. Other CA resident loans made or arranged pursuant to a California Financing Law license. NMLS # 1353190.</div>';
    return w;
  }

  /* Insert/keep finance immediately before the Blanks upsell while it's shown;
     remove it if the upsell isn't visible (pre-upload / upload cleared).
     NOTE: the by-size-middle-scroll redesign (nt-dtf-3col) RELOCATES this row into its
     step-3 card and can wrap the upsell. So we (a) find the upsell anywhere in the sticky,
     and (b) dedup GLOBALLY. The old direct-child-only check missed the relocated row and
     re-injected on every redesign mutation, stacking a dozen copies. */
  function sync() {
    var sticky = document.querySelector('.product-text.element--is-sticky');
    if (!sticky) return;
    var upsell = sticky.querySelector('[id*="grt-upsell"]');
    var show = upsell && upsell.getBoundingClientRect().height > 20;
    var all = document.querySelectorAll('.' + FIN_CLASS);
    if (!show) { Array.prototype.forEach.call(all, function (e) { e.remove(); }); return; }
    if (all.length) {
      for (var i = 1; i < all.length; i++) all[i].remove();   // kill any duplicates from a prior loop
      var keep = all[0];
      /* Only reposition it ourselves in the plain V1 layout (row + upsell both loose in the
         sticky). If the redesign relocated it (parent is its step card), leave placement alone. */
      if (keep.parentElement === sticky && upsell.parentElement === sticky && keep.nextElementSibling !== upsell) {
        sticky.insertBefore(keep, upsell);
      }
      return;
    }
    injectStyles();
    if (upsell.parentElement === sticky) sticky.insertBefore(buildFinance(), upsell);
    else sticky.appendChild(buildFinance());   // redesign will relocate into its step card
  }

  function boot() {
    sync();
    [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(sync, ms); });
    var target = document.querySelector('.product-text.element--is-sticky') || document.body;
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; sync(); }, 120);
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
